'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var MORE_BUTTON_VALUE = exports.MORE_BUTTON_VALUE = 'more';
var MORE_BUTTON_WIDTH = exports.MORE_BUTTON_WIDTH = 100;
var DIVIDER_WIDTH = exports.DIVIDER_WIDTH = 4;